import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// navigation.js
const listeners: any = []

export const navigate = (path: string | number) => {
  listeners.forEach((listener: any) => listener(path))
}

export const NavigationHandler = () => {
  const navigate = useNavigate()

  const addNavigationListener = (listener: any) => {
    listeners.push(listener)
  }

  useEffect(() => {
    addNavigationListener(navigate)
  }, [navigate])

  return null
}
